import styled, { keyframes } from "styled-components";

const blinkAnimation = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

export const ServicesSection = styled.section`
  display: block;
  text-align: center;
  align-content: center;
  padding: 4vw 8vw 5vw 8vw;
  background: transparent;
  min-width: 134vh;

  h2,
  h3 {
    color: #ff8412;
    margin: 1rem 0 0 0;
  }
  h2 {
    font-size: 2.5rem;
    animation: ${blinkAnimation} 3s infinite ease-in-out;
  }

  h3 {
    font-size: 1.5rem;
    animation: ${blinkAnimation} 3s infinite ease-in-out;
  }

  p {
    font-size: 1.5rem;
  }

  .services-benefits {
    p {
      margin: 1rem 0 0 0;
    }
    .div-img {
      width: 45rem;
      height: auto;
      margin: 3rem auto 1.5rem auto;

      img {
        border-radius: 0.5rem;
        width: 38rem;
        height: auto;
        max-width: 100%;
        animation: ${blinkAnimation} 3s infinite ease-in-out;
      }
    }
  }

  .services-info {
    display: flex;
    flex-direction: column;
    padding-top: 6rem;

    /* h2 {
      animation: ${blinkAnimation} 3s infinite ease-in-out;
    } */

    .services-grid {
      display: grid;
      grid-template-columns: 0.5fr 0.2fr 0.5fr;
      gap: 2rem;
      margin: 2.5rem 3rem 3rem 3rem;
      background: transparent;

      .sum-symbol {
        color: #ff8412;
        margin: 1rem 0 0 0;
        font-size: 8rem;
        font-weight: 700;
        animation: ${blinkAnimation} 3s infinite ease-in-out;
      }

      div {
        padding: 3rem;
      }

      div:nth-of-type(2) {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
    }

    .contact-us {
      align-self: center;
      background-color: #ff8412;
      padding: 0;
      font-size: 1.25rem;
      font-weight: 600;
      border-radius: 0.8rem;
      border: 1px solid #172736;
      height: 3rem;
      width: 16rem;
      color: #fff;
      animation: ${blinkAnimation} 2s infinite ease-in-out;
    }
    .contact-us:hover {
      background-color: #a76323;
      color: #ded9e0;
      cursor: pointer;
    }
  }
`;
